import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { customerApi } from '../api/customerApi';
import { ToastMessage } from '../components/ToastMessage';

interface RemoveAccessParams {
  customerId: string;
  profileId: number;
}

export const useRemoveAccess = () => {
  const queryClient = useQueryClient();

  const onSuccess = useCallback(
    (_: any, variables: { customerId: string }) => {
      queryClient.invalidateQueries({
        queryKey: ['access-allowed', variables.customerId],
      });
      ToastMessage({
        content: 'Acesso removido com sucesso!',
        type: 'success',
      });
    },
    [queryClient]
  );

  const onError = useCallback(() => {
    ToastMessage({
      content: 'Falha ao remover o acesso. Tente novamente!',
      type: 'error',
    });
  }, [queryClient]);

  const { mutateAsync: removeAccess, isPending: isLoadingRemoveAccess } =
    useMutation({
      mutationFn: ({ customerId, profileId }: RemoveAccessParams) =>
        customerApi.removeAccess(customerId, profileId),
      onSuccess,
      onError,
    });

  return { removeAccess, isLoadingRemoveAccess };
};
